import {Box, Card, CardContent, Typography} from '@mui/material';
import {ReactNode} from 'react';

interface SummaryCardProps {
    title: string;
    value: string;
    subtitle?: string;
    icon: ReactNode;
    color?: string;
}

const SummaryCard = (props: SummaryCardProps) => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant={'body2'} color={'text.secondary'}>
                            {props.title}
                        </Typography>
                        <Typography variant={'h4'} sx={{ fontWeight: 'bold', color: props.color || 'primary.main' }}>
                            {props.value}
                        </Typography>
                        {props.subtitle && (
                            <Typography variant={'body2'} color={'text.secondary'}>
                                {props.subtitle}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ color: props.color || 'primary.main', opacity: 0.7, fontSize: 40 }}>
                        {props.icon}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default SummaryCard;
